import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const IndexFaq = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqData = [
    {
      question: "Quand est-ce que les retraits seront disponibles avec le plan gratuit ?",
      answer: "D'ici le 15 février, nous allons trouver une solution et vous tenir informé."
    },
    {
      question: "Je ne comprends pas comment utiliser l'application.",
      answer: "Contactez-nous via le support pour une prise en charge gratuite."
    },
    {
      question: "J'ai remarqué un dysfonctionnement ou je veux apporter une amélioration.",
      answer: "Contactez-nous via le support."
    },
    {
      question: "Comment contacter le service client ?",
      answer: "Notre service client est disponible par e-mail 24h/24, 7j/7. Vous pouvez également nous appeler au 01 23 45 67 89 du lundi au vendredi, de 9h à 18h."
    }
  ];
  

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg h-screen">
      <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
        Questions Fréquentes
      </h2>
      
      <div className="space-y-4">
        {faqData.map((item, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg overflow-hidden"
          >
            <button
              className="w-full px-6 py-4 flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
              onClick={() => toggleQuestion(index)}
              aria-expanded={openIndex === index}
            >
              <span className="text-lg font-medium text-gray-700 text-left">
                {item.question}
              </span>
              {openIndex === index ? (
                <ChevronUp className="w-5 h-5 text-gray-600" />
              ) : (
                <ChevronDown className="w-5 h-5 text-gray-600" />
              )}
            </button>
            
            <div
              className={`px-6 overflow-hidden transition-all duration-200 ease-in-out ${
                openIndex === index ? 'max-h-96 py-4' : 'max-h-0'
              }`}
            >
              <p className="text-gray-600">
                {item.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndexFaq;